export default __webpack_public_path__ + "prothomalo-black.png";